import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_7754_29985)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_7754_29985"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "12",
  height: "12",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M10.5 1.5H1.5M6 10.5V3.5M6 3.5L2.5 7M6 3.5L9.5 7",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}